import React from 'react';
import PropTypes from 'prop-types';
var sizeByDensity = {
  high: 3,
  medium: 5,
  low: 5,
  touch: 7
};

var WarningIndicator = function WarningIndicator(_ref) {
  var className = _ref.className,
      density = _ref.density;
  var size = sizeByDensity[density]; // e.g. medium = 0,5 5,5 5,0

  var points = "0,".concat(size, " ").concat(size, ",").concat(size, " ").concat(size, ",0");
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    focusable: false,
    height: size,
    width: size
  }, /*#__PURE__*/React.createElement("polygon", {
    points: points
  }));
};

process.env.NODE_ENV !== "production" ? WarningIndicator.propTypes = {
  className: PropTypes.string,
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high'])
} : void 0;
export default WarningIndicator;